__turbopack_context__.v({
  "heroImgWrapper": "STCareerHero-module__4AS2Yq__heroImgWrapper",
  "heroSection": "STCareerHero-module__4AS2Yq__heroSection",
  "heroTextWrapper": "STCareerHero-module__4AS2Yq__heroTextWrapper",
  "heroTitle": "STCareerHero-module__4AS2Yq__heroTitle",
});
